module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-date-picker', {
    class: _vm.pickerClass,
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "-",
      "start-placeholder": "Od",
      "end-placeholder": "Do",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73a6c57b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/DateRangePicker.vue
// module id = 824
// module chunks = 0